var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isPopularArticle ? _c("table-widget") : _vm._e(),
      _vm._v(" "),
      _vm.isInternalPopularArticle
        ? _c("div", { staticClass: "today_bubble" })
        : _vm._e(),
      _vm._v(" "),
      _vm.widgetType === "card"
        ? _c("card-widget", {
            ref: "cardWidget",
            attrs: { articles: _vm.articles, config: _vm.config },
          })
        : _vm.widgetType === "text"
        ? _c("text-widget", {
            attrs: { articles: _vm.articles, config: _vm.config },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }